export default "__VITE_ASSET__UZPK435x__"